// Jul-2026 (User-Wunsch) — Einheitliche rechtliche Pflicht-Fußzeile für
// On-Screen-Dokument-Vorschauen (Rechnung, Kaufvertrag, Angebot …). Spiegelt die
// PDF-Fußzeile (pdf_branding.standard_footer): Firmierung, Anschrift, Sitz der
// Gesellschaft, Handelsregister (HRB) + Registergericht, Steuernummer, USt-IdNr.,
// Geschäftsführer. Fehlende Felder werden ausgelassen.
export const LegalFooter = ({ dealer, className = "" }) => {
    const d = dealer || {};
    const company = d.company_name || d.name || "";
    const street = [d.address || d.street, d.house_number].filter(Boolean).join(" ").trim();
    const plzOrt = [d.zip || d.postal_code, d.city].filter(Boolean).join(" ").trim();
    const seat = d.company_seat || d.city;
    const regNo = d.register_number || d.handelsregister;
    const regNoDisp = regNo
        ? (/^(HRB|HRA|GNR|VR|PR)/i.test(String(regNo).trim()) ? regNo : `HRB ${regNo}`)
        : null;
    const regCourt = d.register_court;
    const taxNr = d.tax_number || d.tax_id;
    const ustId = d.ust_id || d.vat_id || d.ustid;
    const gf = d.managing_director;

    const col1 = [company && <div key="c" className="font-bold text-gray-700">{company}</div>,
        street && <div key="s">{street}</div>, plzOrt && <div key="p">{plzOrt}</div>].filter(Boolean);
    const col2 = [seat && <div key="seat">Sitz der Gesellschaft: {seat}</div>,
        gf && <div key="gf">Geschäftsführer: {gf}</div>,
        (regNoDisp || regCourt) && <div key="reg">{[regNoDisp, regCourt && `Registergericht ${regCourt}`].filter(Boolean).join(" · ")}</div>].filter(Boolean);
    const col3 = [taxNr && <div key="t">Steuernr.: {taxNr}</div>,
        ustId && <div key="u">USt-IdNr.: {ustId}</div>].filter(Boolean);

    if (!col1.length && !col2.length && !col3.length) return null;
    return (
        <div className={`border-t border-gray-300 pt-2 mt-3 grid grid-cols-1 sm:grid-cols-3 gap-x-4 gap-y-0.5 text-[10px] leading-tight text-gray-500 ${className}`} data-testid="legal-footer">
            <div>{col1}</div>
            <div>{col2}</div>
            <div>{col3}</div>
        </div>
    );
};

export default LegalFooter;
